module.exports = __webpack_public_path__ + "img/klimakteriepodden.39c77335.jpg";